"";
/*
 *   File : editor.js
 *   Author : https://rudo-admin.com
 *   Description : Custom wysiwyg editor component
 *   Integrations : CKEditor (no React wrapper)
 *   Version : 1.0.0
 */

import React, { memo, useState, useRef, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../../Style/Components/editor.scss";

//style

const CustomEditor = (props) => {
  const [ckEditorData, setCkEditorData] = useState(props.editorState);
  const editorRef = useRef();

  useEffect(() => {
  if (props.editorState !== ckEditorData) {
    setCkEditorData(props.editorState || "");
    if (editorRef.current) {
      editorRef.current.setData(props.editorState || "");
    }
  }
}, [props.editorState,ckEditorData]);
  const _onCKEditorChange = (event, editor) => {
    const data = editor.getData();
    setCkEditorData(data);
    props.onEditorStateChange(data);
  };

  return (
    <div className={`${props.className} d-flex flex-grow-1 flex-column`}>
      {props.label && (
        <label
          className={`${props.labelStyle} pt-3 padding-24px-all border-radius-16  padding-96px-bottom `}
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="overflow-hidden d-flex flex-column e-scroll-style">
        <CKEditor
          editor={ClassicEditor}
          data={ckEditorData}
          config={{
            toolbar: [
              "bold",
              "italic",
              "underline",
              "|",
              "alignment:left",
              "alignment:center",
              "alignment:right",
              "alignment:justify",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "outdent",
              "indent",
              "|",
              "link",
            ],
            alignment: {
              options: ["left", "center", "right", "justify"], // specify available options
            },

            fontColor: {
              colors: [
                { color: "#FFFFFF", label: "White" },
                { color: "#000000", label: "Black" },
              ],
            },
            fontBackgroundColor: {
              colors: [
                { color: "#FFFFFF", label: "White" },
                { color: "#000000", label: "Black" },
              ],
            },
          }}
          onReady={(editor) => {
            editorRef.current = editor;
            editor.ui.view.editable.element.style.height = "100%"; // force full height
            editor.ui.view.editable.element.style.minHeight = "100%";
            const toolbar = editor.ui.view.toolbar.element;
            const items = toolbar.querySelector(".ck-toolbar__items").children;
            Array.from(items).forEach((item) => {
              if (item.classList.contains("ck-toolbar__separator")) {
                const gap = document.createElement("div");
                gap.style.width = "72px";
                gap.style.display = "inline-block";
                gap.style.flexShrink = "0";
                item.replaceWith(gap);
              }
            });
          }}
          onChange={_onCKEditorChange}
        />
      </div>

      <p className="mb-0 pt-1 e-text-cg-red e-font-12 line-height-12px margin-neg-2px-top">
        {props.error}
      </p>
    </div>
  );
};

export default memo(CustomEditor);
